<template>
<span>
  <el-tag v-if="type === 0" type="primary" size="small">Baixa</el-tag>
  <el-tag v-if="type === 1" type="info" size="small">Média</el-tag>
  <el-tag v-if="type === 2" type="warning" size="small">Alta</el-tag>
</span>
</template>
<script>
export default {
  name: "TaskPriority",
  props: {
    type: {
      type: Number,
      required: true      
    },
  },
  computed: {    
  },
};
</script>

<style scoped>
.prioridade-baixa {  
}
.prioridade-media {  
}
.prioridade-alta {  
}
</style>